/**
 * Route definition for /chains/flare
 *
 * Renders the shared ChainPage with the `flare` article. Chain facts live in
 * `@/data/chains`; presentation and SEO live in `@/components/ChainPage`.
 *
 * @module routes/chains/flare
 * @category Routes
 */
import { createFileRoute } from '@tanstack/react-router'
import ChainPage from '@/components/ChainPage'

export const Route = createFileRoute('/$locale/chains/flare')({
  component: function FlareChainPage() {
    return <ChainPage slug="flare" />
  },
})
